import { render } from "./ExtensionReasonView.vue?vue&type=template&id=f34f4b80&scoped=true&ts=true"
import script from "./ExtensionReasonView.vue?vue&type=script&lang=ts"
export * from "./ExtensionReasonView.vue?vue&type=script&lang=ts"

import "./ExtensionReasonView.vue?vue&type=style&index=0&id=f34f4b80&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f34f4b80"]])

export default __exports__